import { Component, ElementRef, inject, Input, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { CmsService, WindowRef } from '@spartacus/core';
import { HamburgerMenuService, NavigationNode, NavigationUIComponent } from '@spartacus/storefront';

@Component({
    selector: 'kb-navigation-ui',
    templateUrl: './kb-navigation-ui.component.html',
    styleUrls: ['./kb-navigation-ui.component.scss'],
    standalone: false
})
export class KbNavigationUiComponent extends NavigationUIComponent {

    public cmsService = inject(CmsService)
    @Input() declare node: NavigationNode | null;
    addressData$ = this.cmsService.getComponentData('addresspara');
    socialMedia$ = this.cmsService.getComponentData('socialMediaIconsPara');
    socialMediaIconsKB$ = this.cmsService.getComponentData('socialMediaIconsParaKB');
    addressparaKB$ = this.cmsService.getComponentData('addressparaKB');

    constructor(router: Router,
        renderer: Renderer2,
        elemRef: ElementRef,
        hamburgerMenuService: HamburgerMenuService,
        winRef: WindowRef) {
        super(router, renderer, elemRef, hamburgerMenuService, winRef)
    }


}
